import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { MailService } from 'src/app/core/_services/mail.service';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';

interface FaqSection {
  titleKey: string;
  sectionKey: string;
  count: number[];
}

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent {
  contactForm = {
    name: '',
    email: '',
    subject: '',
    message: ''
  };

  faqSections: FaqSection[] = [
    { titleKey: 'help_faq_section_1', sectionKey: 's1', count: [1, 2, 3, 4, 5] },
    { titleKey: 'help_faq_section_2', sectionKey: 's2', count: [1, 2, 3, 4, 5, 6] },
    { titleKey: 'help_faq_section_3', sectionKey: 's3', count: [1, 2, 3] },
    { titleKey: 'help_faq_section_4', sectionKey: 's4', count: [1, 2, 3, 4] },
    { titleKey: 'help_faq_section_5', sectionKey: 's5', count: [1, 2, 3, 4, 5, 6] },
    { titleKey: 'help_faq_section_6', sectionKey: 's6', count: [1] }
  ];

  constructor(
    private mailService: MailService,
    private snackbarService: SnackbarService
  ) {}

  onSubmit(form: NgForm) {
    this.mailService
      .sendHelpRequest({
        Name: this.contactForm.name,
        Email: this.contactForm.email,
        Subject: this.contactForm.subject,
        Message: this.contactForm.message
      })
      .subscribe({
        next: () => {
          this.snackbarService.open(SnackbarTypes.mailSend);
          form.resetForm();
        },
        error: () => this.snackbarService.open(SnackbarTypes.error)
      });
  }
}
